<template>
  <!-- v-if="list && list.length > 1" -->
  <div class="SpecialArea"
       v-if="list && list.length > 1">
    <!-- 分区线 -->
    <div class="Underline"></div>
    <div class="banner-swiper">
      <div class="swiper-container"
           ref="swipe">
        <div class="swiper-wrapper">
          <div v-for="item in list"
               :key="item.id"
               class="swiper-slide banner-default">
            <a :href="item.link.linkUrl || 'javascript:;'"
               target="_blank">
              <img :src="slimImg(item.link.img31)"
                   alt=""
                   :class="{'img1':list.length < 3 ,'img2':list.length > 2}" />
            </a>
          </div>
        </div>
        <div class="swiper-pagination"
             slot="pagination"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper/js/swiper.min.js'
import 'swiper/css/swiper.css'
export default {
  name: 'SpecialArea',
  data () {
    return {
      defaultList: [
        {
          id: 1,
          link: {
            img43: require('../../assets/img/new_banner_bg.png'),
            linkUrl: ''
          },
          type: 'default'
        }
      ],
      list: []
    }
  },
  props: ['homeData'],
  created () {
    this.getBanner()
  },
  watch: {
    // list() {
    //   var _this = this
    //   setTimeout(() => {
    //     _this.$refs.swipe.resize() //报错，没有这个方法
    //   }, 500);
    // }
  },
  methods: {
    getBanner () {
      this.$Api
        .listZoneList({
          // relateType: 4,
          // blockType: 6
          tabId: 1
        })
        .then(data => {
          if (data && data.list && data.list.length > 0) {
            this.list = data.list
            if (this.list.length > 1) {
              this.$nextTick(() => {
                this.slide()
              })
            }
          } else {
            this.list = []
          }
        })
        .catch(() => {
          this.list = []
        })
    },
    slide () {
      setTimeout(() => {
        new Swiper('.SpecialArea .swiper-container', {
          loop: this.list.length > 3,
          autoplay: {
            delay: 4000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          pagination: {
            el: this.list.length > 3 && '.swiper-pagination'
          },
          slidesPerView: this.list.length == 2 ? 2 : 3,
          // slidesPerGroup: this.list.length == 2 ? 2 : 3,
          slidesPerGroup: 1,
          noSwiping: this.list.length < 3,
          loopFillGroupWithBlank: true,
          loopedSlides: this.list.length,
          grid: {
            fill: 'column',
            rows: 1
          }
        })
      }, 200)
    },
    slimImg (img) {
      return this.$Common.slimImg(img, 750)
    }
  }
}
</script>
<style lang="scss">
.SpecialArea {
  // height: 34.66vw;
  // margin-bottom: 11vw;
  //   background: #1a2ea5;
  .banner-default {
    height: 100%;
    text-align: center;
    .img1 {
      width: 44vw;
      height: 16.544vw;
    }
    .img2 {
      width: 30vw;
      height: 16.544vw;
    }
  }
  .banner-swiper {
    height: 100%;
    .swiper-container {
      height: 100%;
      a {
        display: block;
        height: 100%;
        font-size: 0;
        line-height: 0;
      }
      .swiper-pagination {
        text-align: right;
        padding-right: 4vw;
        box-sizing: border-box;
        bottom: 3vw;
        font-size: 0;
        line-height: 1;
        .swiper-pagination-bullet {
          width: 5.99vw;
          height: 1.042vw;
          border-radius: 0;
          background: rgba(255, 255, 255, 0.3);
          opacity: 1;
          transition: all 0.3s;
        }
        .swiper-pagination-bullet-active {
          background: #fff;
        }
      }
    }
  }
}
</style>
